import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatDialogModule} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatMenuModule} from "@angular/material/menu";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatTooltip} from "@angular/material/tooltip";
import {MatSlider, MatSliderRangeThumb} from "@angular/material/slider";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {AngularEditorModule} from "@kolkov/angular-editor";
import {FrontendButtonComponent} from './frontend-button/frontend-button.component';
import {FrontendCheckBoxComponent} from './frontend-check-box/frontend-check-box.component';
import {FrontendDateComponent} from './frontend-date/frontend-date.component';
import {FrontendDropdownComponent} from './frontend-dropdown/frontend-dropdown.component';
import {FrontendEditorComponent} from './frontend-editor/frontend-editor.component';
import {FrontendFileChooserComponent} from './frontend-file-chooser/frontend-file-chooser.component';
import {ImagePreviewDialogComponent} from './frontend-file-chooser/image-preview-dialog/image-preview-dialog.component';
import {FrontendFilterComponent} from './frontend-filter/frontend-filter.component';
import {FrontendInputComponent} from './frontend-input/frontend-input.component';
import {FrontendMapComponent} from './frontend-map/frontend-map.component';
import {FrontendSelectComponent} from './frontend-select/frontend-select.component';
import {FrontendSliderComponent} from './frontend-slider/frontend-slider.component';
import {FrontendStarRateComponent} from './frontend-star-rate/frontend-star-rate.component';
import {FrontendTableComponent} from './frontend-table/frontend-table.component';
import {FrontendTextAreaComponent} from './frontend-text-area/frontend-text-area.component';
import {SelectUserComponent} from './select-user/select-user.component';
import {OnlineTranslate} from '../../util/pipes/online.translate';
import {TimePipe} from '../../util/pipes/time';
import {ClickOutsideDirective} from '../../util/service/directive/click-outside.directive';
import {NumberMaskDirective} from '../../util/service/directive/number-mask.directive';
import {TranslateModule} from '@ngx-translate/core';
import {NoKeyboardActionDirective} from '../../util/service/directive/no-keyboard-action.directive';
import {ImageBaseAttributeDirective} from '../../util/service/directive/image-base-attribute.directive';
import {EnglishNumberOnlyDirective} from '../../util/service/directive/english-number-only.directive';
import {MobileDirective} from '../../util/service/directive/mobile.directive';
import {PersianDateTimePickerModule} from '@s.motevalian/persian-date-time-picker';
import {OtpComponent} from './otp/otp.component';

@NgModule({
  declarations: [
    FrontendButtonComponent,
    FrontendCheckBoxComponent,
    FrontendDateComponent,
    FrontendDropdownComponent,
    FrontendEditorComponent,
    FrontendFileChooserComponent,
    ImagePreviewDialogComponent,
    FrontendFilterComponent,
    FrontendInputComponent,
    FrontendMapComponent,
    FrontendSelectComponent,
    FrontendSliderComponent,
    FrontendStarRateComponent,
    FrontendTableComponent,
    FrontendTextAreaComponent,
    SelectUserComponent,
    OnlineTranslate,
    TimePipe,
    ClickOutsideDirective,
    NumberMaskDirective,
    NoKeyboardActionDirective,
    ImageBaseAttributeDirective,
    OtpComponent
  ],
  exports: [
    FrontendButtonComponent,
    FrontendCheckBoxComponent,
    FrontendDateComponent,
    FrontendDropdownComponent,
    FrontendEditorComponent,
    FrontendFileChooserComponent,
    FrontendFilterComponent,
    FrontendInputComponent,
    FrontendMapComponent,
    FrontendSelectComponent,
    FrontendSliderComponent,
    FrontendStarRateComponent,
    FrontendTableComponent,
    FrontendTextAreaComponent,
    SelectUserComponent,
    OnlineTranslate,
    TimePipe,
    ClickOutsideDirective,
    NumberMaskDirective,
    TranslateModule,
    NoKeyboardActionDirective,
    ImageBaseAttributeDirective,
    OtpComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatRadioButton,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTooltip,
    ReactiveFormsModule,
    TranslateModule,
    MatSlider,
    MatSliderRangeThumb,
    MatProgressSpinnerModule,
    AngularEditorModule,
    MatRadioGroup,
    EnglishNumberOnlyDirective,
    MobileDirective,
    PersianDateTimePickerModule
  ]
})
export class BaseModule {
}
